export const GET_ENDORSING_OFFICES =
  'ENDORSING_OFFICES/get_ordinance_offices';
export const GET_SINGLE_ENDORSING_OFFICES =
  'ENDORSING_OFFICES/get_single_ordinance_offices';
export const UPDATE_ENDORSING_OFFICES =
  'ENDORSING_OFFICES/update_ordinance_offices';
export const CREATE_ENDORSING_OFFICES =
  'ENDORSING_OFFICES/create_ordinance_offices';
export const REMOVE_ENDORSING_OFFICES =
  'ENDORSING_OFFICES/remove_ordinance_offices';
export const ATTACH_ADMINISTRATOR =
  'ENDORSING_OFFICES/attach_administrator';
export const DETACH_ADMINISTRATOR =
  'ENDORSING_OFFICES/detach_administrator';
export const GET_ADMINISTRATOR =
  'ENDORSING_OFFICES/get_administrator';
export const DELETE_ENDORSING_OFFICES = 
  'ENDORSING_OFFICES/delete_ordinance_offices';

export const FORM_DATA = {
  name: '',
  description: '',
  code: '',
  for_new: 0,
  for_renewal: 0,
  for_change: 0,
  for_delinquent: 0,
  for_retirement: 0,
};
